import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { TRAVEL_SERVICES } from '../../shared/constants/api-constants';

@Component({
  selector: 'app-voucher-selection-popover',
  templateUrl: './voucher-selection-popover.component.html',
  styleUrls: ['./voucher-selection-popover.component.scss'],
})
export class VoucherSelectionPopoverComponent implements OnInit {

  voucherSectionsForm!: FormGroup;

  leadDetails: any;
  voucherDetails: any;

  @Input() onActionPerformed!: (data: any) => void;

  constructor(private fb: FormBuilder,
    private _popoverController: PopoverController
  ) { }

  ngOnInit(): void {
    this.voucherSectionsForm = this.fb.group({
      hotelsVoucher: [false],
      transportationVoucher: [false],
      routeCraftVoucher: [false]
    }, {
      validators: (form: FormGroup) => {
      const controls = ['hotelsVoucher', 'transportationVoucher', 'routeCraftVoucher'];
      const enabledChecked = controls.some(
        key => form.get(key)?.enabled && form.get(key)?.value === true
      );
      return enabledChecked ? null : { atLeastOne: true };
      }
    });

    if (this.leadDetails && this.voucherDetails) {
      if (!this.voucherDetails?.showHotels || !this.leadDetails?.travelServices?.includes(TRAVEL_SERVICES.HOTELS)) {
        this.voucherSectionsForm.get('hotelsVoucher')?.disable();
      }
      if (!this.voucherDetails?.showTransportation || !this.leadDetails?.travelServices?.includes(TRAVEL_SERVICES.TRANSPORTATION)) {
        this.voucherSectionsForm.get('transportationVoucher')?.disable();
      }
      if (!this.voucherDetails?.showSightSeeing || !this.leadDetails?.travelServices?.includes(TRAVEL_SERVICES.SIGHTSEEING)) {
        this.voucherSectionsForm.get('routeCraftVoucher')?.disable();
      }
    }
  }

  toggleFullVoucher(event: any) {
    const isChecked = event.target.checked;    
    this.voucherSectionsForm.patchValue({
      hotelsVoucher: isChecked,
      transportationVoucher: isChecked,
      routeCraftVoucher: isChecked
    });
  }

  isFullVoucherChecked(): boolean {
    const controls = ['hotelsVoucher', 'transportationVoucher', 'routeCraftVoucher'];
    const enabledControls = controls.filter(key => this.voucherSectionsForm.get(key)?.enabled);
    return enabledControls.length > 0 && enabledControls.every(key => this.voucherSectionsForm.get(key)?.value === true);
  }

  onSubmit(): void {
    if (this.voucherSectionsForm.valid) {
      let sectionsList = [];
      if (this.voucherSectionsForm.value.hotelsVoucher) {
        sectionsList.push('Accommodation');
      }
      if (this.voucherSectionsForm.value.transportationVoucher) {
        sectionsList.push('Transportation');
      }
      if (this.voucherSectionsForm.value.routeCraftVoucher) {
        sectionsList.push('RouteCraft');
      }

      this.onActionPerformed(sectionsList);
      this.closeModal();
    } else {
      this.voucherSectionsForm.markAllAsTouched();
    }
  }

  closeModal() {
    this._popoverController.dismiss();
  }

}
